import { useQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useUserInformation } from '@hooks/useUserInformation';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';
import { AssistantType } from '@src/types/attribution';

import { partnerConnectorList } from '../features/Partner/query';

const usePartnerConnectors = () => {
  const userInformation = useUserInformation();
  const { appointment } = useAppointmentContext();
  const isPartner = userInformation?.type === AssistantType.PARTNER;
  const isAppointment = !!appointment?.id;
  const positionId = isPartner ? userInformation?.partnerPositionId : undefined;
  const appointmentId =
    !isPartner && isAppointment ? appointment?.id : undefined;
  const skip = !isPartner && !isAppointment;

  const setSnackbarError = useSnackbarError();
  const {
    data,
    loading,
    error: connectorsError,
  } = useQuery(partnerConnectorList, {
    variables: {
      positionId,
      appointmentId,
    },
    skip,
  });

  useEffect(() => {
    if (connectorsError) {
      setSnackbarError(new Error('Could not load connectors list'));
    }
  }, [connectorsError, setSnackbarError]);

  if (skip) {
    return {
      connectors: null,
      loading: false,
    };
  }

  return {
    connectors: data?.partnerConnectors?.connectors ?? [],
    loading,
  };
};

export { usePartnerConnectors };
